import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start with the requested time: 23:58:17
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 58,
    seconds: 17
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              // Reset or stop when it hits 0
              hours = 23;
            }
          }
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 md:gap-4 text-brand-navy font-display font-bold text-3xl md:text-5xl" data-id="element-241">
      <div className="flex flex-col items-center" data-id="element-242">
        <div className="bg-white px-3 py-2 md:px-4 md:py-3 rounded-lg shadow-sm border border-gray-100 min-w-[60px] md:min-w-[80px] text-center" data-id="element-243">
          {formatNumber(timeLeft.hours)}
        </div>
        <span className="text-xs md:text-sm font-sans font-medium text-gray-500 mt-1 uppercase tracking-wider" data-id="element-244">
          Horas
        </span>
      </div>
      <span className="text-brand-orange -mt-6" data-id="element-245">:</span>
      <div className="flex flex-col items-center" data-id="element-246">
        <div className="bg-white px-3 py-2 md:px-4 md:py-3 rounded-lg shadow-sm border border-gray-100 min-w-[60px] md:min-w-[80px] text-center" data-id="element-247">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-xs md:text-sm font-sans font-medium text-gray-500 mt-1 uppercase tracking-wider" data-id="element-248">
          Min
        </span>
      </div>
      <span className="text-brand-orange -mt-6" data-id="element-249">:</span>
      <div className="flex flex-col items-center" data-id="element-250">
        <div className="bg-white px-3 py-2 md:px-4 md:py-3 rounded-lg shadow-sm border border-gray-100 min-w-[60px] md:min-w-[80px] text-center text-brand-orange" data-id="element-251">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-xs md:text-sm font-sans font-medium text-gray-500 mt-1 uppercase tracking-wider" data-id="element-252">
          Seg
        </span>
      </div>
    </div>;
}